import Icon from '../components/Icon.vue'

Icon.register({
  robot: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M0 256c0-17.7 14.3-32 32-32h32v192h-32c-17.7 0-32-14.3-32-32v-128zM464 96c44.2 0 80 35.8 80 80v272c0 35.3-28.7 64-64 64h-320c-35.3 0-64-28.7-64-64v-272c0-44.2 35.8-80 80-80h112v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64h112zM256 416v-32h-64v32h64zM224 296c22.1 0 40-17.9 40-40s-17.9-40-40-40-40 17.9-40 40 17.9 40 40 40zM352 416v-32h-64v32h64zM448 416v-32h-64v32h64zM416 296c22.1 0 40-17.9 40-40s-17.9-40-40-40-40 17.9-40 40 17.9 40 40 40zM608 224c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-32v-192h32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/robot.js
// module id = null
// module chunks = 